/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useCallback, useEffect, useState } from "react";
import { $api } from "libs/axios";

export function usePagination<T>(
	link: string,
	params: { [key: string]: any } = {},
	then: (arr: T[]) => void,
	ref: React.MutableRefObject<any>,
	dependencies: any[] = [],
	catchHandler?: () => void,
) {
	const [fetch, setFetch] = useState(true);

	const [isFinally, setIsFinally] = useState(false);

	const scroller = useCallback(() => {
		const target = ref.current;
		if (target && !isFinally) {
			const fullHeight = target.scrollHeight;
			const scrollTop = target.scrollTop;
			const { height } = target.getBoundingClientRect();
			if (fullHeight - (scrollTop + height) < 100) {
				if (!fetch) {
					setFetch(true);
				}
			}
		}
	}, [ref, isFinally, fetch]);

	const submit = useCallback(() => {
		$api
			.get(link, { params })
			.then(({ data }) => then(data))
			.catch(catchHandler)
			.finally(() => setFetch(false));
		//eslint-disable-next-line
	}, [link, params, then]);

	useEffect(() => {
		if (fetch && !isFinally && link) {
			if (dependencies.length) {
				const flag = dependencies.every((_) => {
					return !!_;

				});
				if (flag) {
					submit();
				}
			} else {
				submit();
			}
		}
		//eslint-disable-next-line
	}, [fetch, ...dependencies]);
	useEffect(() => {
		ref.current?.addEventListener("scroll", scroller);
		// eslint-disable-next-line react-hooks/exhaustive-deps
		return () => ref.current?.removeEventListener("scroll", scroller);
		//eslint-disable-next-line
	}, [fetch]);

	return {
		fetch,
		setFetch,
		setIsFinally,
	};
}
